/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {removeActiveGoalPiggybankService} from '../api'

export const useMutationRemoveActiveGoalPiggybankService = createReactQueryMutationHook('removeActiveGoalPiggybankService', removeActiveGoalPiggybankService)
